import React from 'react';
import clsx from 'clsx';

import { TickIcon } from 'ui/icons';

import { StepIconProps } from './StepIcon.types';
import { useStyles } from './StepIcon.styles';

export const StepIcon = ({ active, completed, icon }: StepIconProps) => {
  const classes = useStyles();

  const getContent = () => {
    if (completed) {
      return (
        <div className={clsx(classes.circle, classes.visited)}>
          <TickIcon className={classes.tick} />
        </div>
      );
    }

    if (active) {
      return (
        <div className={clsx(classes.circle, classes.visited)}>
          <div className={classes.whiteCircle} />
        </div>
      );
    }

    return <div className={clsx(classes.circle, classes.unvisited)}>{icon}</div>;
  };

  return <div className={classes.root}>{getContent()}</div>;
};
